import type { FC } from 'react';

import Link from 'next/link';
import { useTranslation } from 'next-i18next/pages';

import { TranslationNamespace } from '@/i18n';
import { CheckOutlined } from '@ant-design/icons';

import styles from './PlatformInfo.module.scss';

export const PlatformInfo: FC = () => {
	const { t } = useTranslation(TranslationNamespace.Calculator);
	return (
		<div className={styles.container}>
			<div className={styles.content}>
				<div className={styles.card}>
					<div className={styles.badge}>{t('platform.no-commission')}</div>
					<h3 className={styles.title}>{t('platform.commission-title')}</h3>
					<p className={styles.description}>{t('platform.commission-description')}</p>
					<div className={styles.commissions}>
						<div className={styles.commissionItem}>
							<div className={styles.checkIcon}>
								<CheckOutlined />
							</div>
							<span>{t('platform.purchase-commission')}</span>
						</div>
						<div className={styles.commissionItem}>
							<div className={styles.checkIcon}>
								<CheckOutlined />
							</div>
							<span>{t('platform.sale-commission')}</span>
						</div>
					</div>
				</div>

				<div className={styles.card}>
					<div className={styles.badge}>{t('platform.postpayment')}</div>
					<h3 className={styles.title}>{t('platform.postpayment-title')}</h3>
					<div className={styles.textGroup}>
						<p className={styles.description}>{t('platform.postpayment-description')}</p>
						<p className={styles.description}>{t('platform.postpayment-details')}</p>
					</div>
					<Link className={styles.link} href="/calculator">
						{t('platform.calculate')} &rarr;
					</Link>
				</div>
			</div>
		</div>
	);
};
